import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, TextInput } from '@resurs/midas-react'
import { getText } from '../../../../../internal/TextLabels/text'

const PhoneNumberModal = props => {
  return (
    <Modal
      {...props}
      title={getText('payApply.basisConfirmation.phoneNumberModalTitle')}
      actions={
        <div>
          <Button
            type="link"
            text={getText('payApply.basisConfirmation.cancel')}
            onClick={props.onClose}
          />
          <Button
            type="primary"
            text={getText('payApply.basisConfirmation.sendSms')}
            onClick={props.onSend}
            disabled={props.sendButtonDisabled}
          />
        </div>
      }
    >
      <TextInput
        id="modalPhoneNumberInput"
        value={props.phoneNumber}
        onChange={e => props.onChange(e)}
        required={getText('payApply.basisConfirmation.required')}
      />
    </Modal>
  )
}

PhoneNumberModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onSend: PropTypes.func.isRequired,
  sendButtonDisabled: PropTypes.bool,
  phoneNumber: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

PhoneNumberModal.defaultProps = {
  onClose: () => {},
  sendButtonDisabled: false,
  phoneNumber: '',
}

export default PhoneNumberModal
